package at.theatervogelweide.admin.contract

import io.ktor.resources.Resource

/**
 * The plain HTTP routes (#11): sign-in, sign-out, the current user and images. Everything else goes through [RPC_PATH].
 *
 * - `GET /api/session` the current [Account], 401 without a session
 * - `POST /api/session` sign in with a [SignInRequest]
 * - `DELETE /api/session` sign out
 * - `PUT /api/session/password` change the signed-in account's password with a [ChangePasswordRequest]
 * - `POST /api/password-link` check a one-time link ([PasswordLinkRequest]), answers with [PasswordLinkInfo]
 * - `POST /api/password-link/password` set the password with a one-time link ([SetPasswordRequest]) and sign in
 * - `POST /api/images/{category}` upload one image (multipart, part `file`), answers with [UploadedImage]
 * - `GET /api/images/{category}/{uuid}` download an image
 */
@Resource("/api")
class Api {
    @Resource("session")
    class Session(val parent: Api = Api()) {
        @Resource("password")
        class Password(val parent: Session = Session())
    }

    @Resource("password-link")
    class PasswordLink(val parent: Api = Api()) {
        @Resource("password")
        class Password(val parent: PasswordLink = PasswordLink())
    }

    @Resource("images/{category}")
    class Images(val parent: Api = Api(), val category: ImageCategory) {
        @Resource("{uuid}")
        class Image(val parent: Images, val uuid: String)
    }
}

/** The web app's page for one-time links (#66); the token follows in the fragment, `…/passwort-festlegen#<token>`. */
const val SET_PASSWORD_PATH = "/passwort-festlegen"

/** The kotlinx.rpc WebSocket endpoint. */
const val RPC_PATH = "/api/rpc"

/**
 * Every HTTP request that changes something carries this header. Browsers only let another site set it after a CORS
 * preflight, and the server sends no CORS headers, so a request with it comes from the admin app itself (#16).
 */
const val REQUEST_HEADER = "X-Admin-Request"
const val REQUEST_HEADER_VALUE = "1"

/** The multipart part that holds an uploaded image. */
const val IMAGE_PART = "file"
